import { useProductStore } from '../stores/product.store'

export const useGetSearchProductHook = () => {
  const { productIdSelected, products } = useProductStore()

  const getProduct = () => {
    if (products) {
      return products.find((product) => product.fkProduto === productIdSelected)
    }
  }

  const product = getProduct()

  return {
    product,
  }
}
